<li
  class="select-categorised__item"
  [class.select-categorised__item--basic]="ppIsSelected()"
  [class.select-categorised__item--standard]="!ppIsSelected()"
  (click)="handleOnClick()"
>
  <div class="select-categorised__item--text">
    @if (ppItem().pngIcon) {
      <img ppImage class="select__icon select-categorised__item--icon" [src]="ppItem().pngIcon" />
    }

    <span class="select-categorised__item--label">{{ ppItem().label | ppTranslate }}</span>

    <span class="select-categorised__item--caption">{{ ppItem().caption | ppTranslate }}</span>
  </div>
  <div>
    <span class="select-categorised__pill">{{
      ppItem().isEditible ? 'editable' : 'non-editable'
    }}</span>
  </div>
</li>
